import router from './router'
import store from './store'
import getPageTitle from '@/utils/get-page-title'
import { getXAuthToken, isImpersonating } from './utils/auth' // get token from cookie

const whiteList = ["/login", "/register", "/register/confirm", "/forgotpassword", "/forgotpassword/check", '/sign-agent', '/subscriptions','/subscriptionsv2','/prepare-order', '/order', '/order-finish','/terms', '/redesign/login', '/redesign/subscriptions', '/redesign/order', '/redesign/order-finish']; // no redirect whitelist

function isPublicFormPath(path) {
    return path === '/form' || path.indexOf('/form/') === 0;
}

function isAuthHandoffPath(path) {
    return path === '/auth/handoff' || path.indexOf('/auth/handoff') === 0;
}

function isPublicRedesignInvoicePath(path) {
    return path.indexOf('/redesign/order/') === 0;
}

router.beforeEach(async (to, from, next) => {
    // start progress bar
    document.title = getPageTitle(to.meta.title)

    // Halaman handoff harus dapat dibuka tanpa sesi dan tanpa memicu
    // pemuatan profil dengan token lama.
    if (isAuthHandoffPath(to.path)) {
        next()
        return
    }

    // Halaman form publik harus dapat dibuka tanpa sesi member dan tidak
    // boleh memicu redirect/login meskipun token lama masih tersimpan.
    if (isPublicFormPath(to.path) || isPublicRedesignInvoicePath(to.path)) {
        next()
        return
    }

    const hasTokenMember = getXAuthToken()
    // console.log('hasTokenMember', hasTokenMember)
    const impersonationActive = isImpersonating()

    if (impersonationActive) {
        console.info("[impersonation] guard check", {
            path: to.path,
            hasToken: !!hasTokenMember,
            hasRoles: !!(store.getters.rolesMember && store.getters.rolesMember.length > 0)
        })
    }

    if (hasTokenMember) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next()
        } else {
            const hasRoles = store.getters.rolesMember && store.getters.rolesMember.length > 0
            // console.log('hasRoles', hasRoles)

            if (hasRoles) {
                // console.log('hasRolesx', hasRoles)

                next()

            } else {
                try {

                    store.dispatch('referral/check')
                    const { data } = await store.dispatch('login/getProfile')
                    const { roles } = data
                    const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
                    // console.log('accessRoutesx', accessRoutes)
                    // dynamically add accessible routes
                    router.addRoutes(accessRoutes)
                    next({
                        ...to,
                        replace: true
                    })
                } catch (error) {
                    console.log('catch', error)
                    if (impersonationActive) {
                        console.info("[impersonation] guard profile failed", {
                            ok: false,
                            message: error && error.message ? String(error.message) : "unknown"
                        })
                    }

                    // remove token and go to login page to re-login
                    await store.dispatch('login/removeXAuthToken')
                    next(`/login?redirect=${to.path}`)
                }
                // next()
                // await store.dispatch('login/removeXAuthToken')
                // next(`/login?redirect=${to.path}`)

            }
        }
    } else {
        /* has no token */
        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
        }
    }
    // set page title
    // next()

})

router.afterEach(() => {
    // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js